/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundPaymentResponse
 */
export interface RefundPaymentResponse {
    /**
     * Stripe Refund id (`re_xxx`).
     * @type {string}
     * @memberof RefundPaymentResponse
     */
    refundId: string;
    /**
     * Stripe Refund.status. Typical values — `succeeded`, `pending`, `failed`, `canceled`. Callers treat `succeeded` and `pending` as success (money moved or will move); `failed`/`canceled` mean no money moved.
     * @type {string}
     * @memberof RefundPaymentResponse
     */
    status?: string | null;
    /**
     * Refund amount in minor units echoed back from Stripe.
     * @type {number}
     * @memberof RefundPaymentResponse
     */
    amountCents: number;
    /**
     * ISO currency code (lowercased) echoed back from the refund.
     * @type {string}
     * @memberof RefundPaymentResponse
     */
    currency: string;
    /**
     * True iff `status == "succeeded"`. Callers should also accept `status == "pending"` as non-terminal success before persisting.
     * @type {boolean}
     * @memberof RefundPaymentResponse
     */
    succeeded: boolean;
}

/**
 * Check if a given object implements the RefundPaymentResponse interface.
 */
export function instanceOfRefundPaymentResponse(value: object): value is RefundPaymentResponse {
    if (!('refundId' in value) || value['refundId'] === undefined) return false;
    if (!('amountCents' in value) || value['amountCents'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('succeeded' in value) || value['succeeded'] === undefined) return false;
    return true;
}

export function RefundPaymentResponseFromJSON(json: any): RefundPaymentResponse {
    return RefundPaymentResponseFromJSONTyped(json, false);
}

export function RefundPaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundPaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'refundId': json['refund_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'amountCents': json['amount_cents'],
        'currency': json['currency'],
        'succeeded': json['succeeded'],
    };
}

export function RefundPaymentResponseToJSON(json: any): RefundPaymentResponse {
    return RefundPaymentResponseToJSONTyped(json, false);
}

export function RefundPaymentResponseToJSONTyped(value?: RefundPaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refund_id': value['refundId'],
        'status': value['status'],
        'amount_cents': value['amountCents'],
        'currency': value['currency'],
        'succeeded': value['succeeded'],
    };
}

